export const addDataItems = (data, propertyName, items, decorators = {}) => {
  const arr = data[propertyName];
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    if (!arr.find((obj) => obj.id === item.id)) {
      arr.push({
        ...item,
        ...decorators,
      });
    }
  }
};

export const patchArray = (arr, patches, decorators = {}) => {

  const result = [...arr];

  for (let index = 0; index < patches.length; index++) {
    const patch = patches[index];

    const itemIndex = result.findIndex((item) => item.id === patch.id);

    if (itemIndex !== -1) {
      result[itemIndex] = {
        ...result[itemIndex],
        ...patch,
        ...decorators,
      };
    } else {
      result.push({
        ...patch,
        ...decorators,
      });
    }
  }
  
  return result;
};

export const decorateArray = (arr, decorators = {}) => {
  for (let index = 0; index < arr.length; index++) {
    if (typeof arr[index] === "object") {
      arr[index] = {
        ...decorators,
        ...arr[index]
      }
    }
  }
  return arr;
};